import React from "react";

import get from "lodash/get";
import { FlatButton } from "material-ui";

import SupplementaryDataModal from "../supplementary-data-modal.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PassBucketStore from "../../../stores/PassBucketStore";

class BoxOfficePassSetup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: null
    };

    this.edit = this.edit.bind(this);
    this.closeEditor = this.closeEditor.bind(this);
    this.updatePass = this.updatePass.bind(this);
  }

  static getStores() {
    return [PassBucketStore];
  }

  static getPropsFromStores() {
    return {
      getPassBucketById: PassBucketStore.getPassBucketById
    };
  }

  edit(subitemIndex, passIndex) {
    this.setState({
      editing: {
        subitem: subitemIndex,
        pass: passIndex
      }
    });
  }

  closeEditor() {
    this.setState({
      editing: null
    });
  }

  updatePass(subitemIndex, passIndex, content) {
    let subitems = this.props.orderData.subitems.slice();

    // Fill array with null values if necessary
    if (!subitems[subitemIndex].names) {
      subitems[subitemIndex].names = [];
    }
    if (!subitems[subitemIndex].supplementary_datas) {
      subitems[subitemIndex].supplementary_datas = [];
    }
    while (subitems[subitemIndex].names.length <= passIndex) {
      subitems[subitemIndex].names.push(undefined);
    }
    while (subitems[subitemIndex].supplementary_datas.length <= passIndex) {
      subitems[subitemIndex].supplementary_datas.push(undefined);
    }

    subitems[subitemIndex].names[passIndex] = content.name;
    subitems[subitemIndex].supplementary_datas[passIndex] =
      content.supplementary_data;

    this.props.updateCurrentOrder({
      subitems: subitems
    });
  }

  getStyles() {
    return {
      editPassButton: {
        border: "1px solid",
        lineHeight: "33px",
        marginRight: 7
      }
    };
  }

  render() {
    const styles = this.getStyles();
    let { orderData, headerStyle } = this.props,
      passBucketIndices = orderData.subitems
        ? orderData.subitems
            .map((s, i) => (s.pass_bucket ? i : null))
            .filter(s => s !== null)
        : [];

    if (!passBucketIndices.length) {
      return null;
    }

    if (orderData.customerType === "groupSales") {
      return null;
    }

    return (
      <div>
        {this.state.editing ? (
          <SupplementaryDataModal
            pass={{
              name: get(
                orderData,
                `subitems[${this.state.editing.subitem}].names[${this.state.editing.pass}]`
              ),
              supplementary_data: get(
                orderData,
                `subitems[${this.state.editing.subitem}].supplementary_datas[${this.state.editing.pass}]`,
                {}
              ),
              pass_bucket: this.props.getPassBucketById(
                get(
                  orderData,
                  `subitems[${this.state.editing.subitem}].pass_bucket`
                )
              )
            }}
            onSubmit={content => {
              this.updatePass(
                this.state.editing.subitem,
                this.state.editing.pass,
                content
              );
              this.closeEditor();
            }}
            requestClose={() => this.closeEditor()}
          />
        ) : null}
        <div style={headerStyle}>Pass setup</div>
        <p>Select each new pass to edit the name & data associated with it.</p>
        {passBucketIndices.map(subitemIndex => {
          let subitem = orderData.subitems[subitemIndex],
            passBucket = this.props.getPassBucketById(subitem.pass_bucket) || {
              name: "Pass"
            };

          return (
            <div style={{ marginTop: 7 }}>
              {Array(subitem.quantity)
                .fill()
                .map((_, passIndex) => {
                  return (
                    <FlatButton
                      label={get(
                        subitem,
                        `names[${passIndex}]`,
                        `${passBucket.name} #${passIndex + 1}`
                      )}
                      onClick={() => this.edit(subitemIndex, passIndex)}
                      style={styles.editPassButton}
                    />
                  );
                })}
            </div>
          );
        })}
      </div>
    );
  }
}

export default connectToStores(BoxOfficePassSetup);



// WEBPACK FOOTER //
// ./src/app/components/partials/box-office/box-office-pass-setup.jsx